/** Shared helpers for building stable query keys across the query-hook files. */

export type MaybeId = number | string | null | undefined;

/** IDs from URL params arrive as strings — normalize so keys match regardless of source. */
export const normalizeId = (id: MaybeId): number | null | undefined =>
  id == null ? (id as null | undefined) : Number(id);
